import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useStyles } from "../styles";
import { useStepperData } from "../../../Helpers/Contexts/stepperContext";
import { useRef, useState } from "react";
import FileUpload from "../../../Components/FileUpload";
import { pdfIcon } from "../../../Assets";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { handleFiles } from "../../../Utils/helperFunctions";
import { useToast } from "../../../Helpers/Contexts/toastContext";
import KenLoader from "../../../GlobalComponents/KenLoader";

const qualifications = [
  "Certified Sports Massage Therapist",
  "Diploma in Massage Therapy",
  "Certificate in Therapeutic Massage",
  "Advanced Diploma in Sports & Fitness Massage",
  "Ayurvedic Massage Certification",
  "Other",
];

const CertificateInstitution = () => {
  const classes = useStyles();
  const { showToast } = useToast();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { formData, updateFormData } = useStepperData();
  const [loading, setLoading] = useState(false);

  const handleFileSelect = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    event.preventDefault();

    event.preventDefault();
    setLoading(true);
    const data = await handleFiles(event, [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "application/pdf",
    ]);
    if (data?.success) {
      updateFormData("Masseur_Certification_URL__c", data?.message);
      setLoading(false);
    } else {
      showToast("error", data?.message);
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <KenLoader />
      ) : (
        <>
          <Typography
            variant="h1"
            className={`${classes.headerTitle} label required`}
            mb={2}
          >
            Tell us about your masseur certification
            {/* <span style={{ color: "#DC5959" }}>*</span> */}
          </Typography>
          <Typography className={classes.headerDescription} mb={4}>
            Tell us about your Masseur certification and Insitution
          </Typography>
          <FormControl fullWidth sx={{ mb: 3 }}>
            <Typography variant="subtitle2" mb={1} className="label required">
              Masseur Certification
            </Typography>

            <Select
              labelId="qualification-label"
              value={formData.Masseur_Certification__c || ""}
              placeholder="Highest Qualification"
              displayEmpty
              sx={{
                color: "#fff",
                ".MuiSelect-icon": {
                  color: "#fff",
                },
                backgroundColor: "#2a2a2a",
              }}
              //   IconComponent={ExpandMoreIcon}
              onChange={(e) =>
                updateFormData("Masseur_Certification__c", e.target.value)
              }
            >
              <MenuItem disabled value="">
                <em>Select</em>
              </MenuItem>

              {qualifications.map((qual) => (
                <MenuItem key={qual} value={qual}>
                  {qual}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {formData.Masseur_Certification__c && (
            <>
              {formData.Masseur_Certification__c === "Other" && (
                <>
                  <Typography
                    variant="subtitle2"
                    mb={1}
                    className="label required"
                  >
                    Add your highest qualification
                  </Typography>
                  <TextField
                    fullWidth
                    placeholder="Enter your highest qualification"
                    value={formData.Masseur_Certification_Other__c || ""}
                    onChange={(e) =>
                      updateFormData(
                        "Masseur_Certification_Other__c",
                        e.target.value
                      )
                    }
                  />
                </>
              )}
              <Box
                sx={{
                  mb: 2,
                }}
              >
                {formData?.Masseur_Certification_URL__c ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 2,
                      background: "#161616",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      marginBottom: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: "12px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={pdfIcon}
                        alt="Document Icon"
                        style={{ width: "24px", height: "24px" }}
                      />
                      <Box>
                        <Typography variant="body1" color="white">
                          certificate
                        </Typography>
                        <Typography variant="body1" color={"success.main"}>
                          Uploaded
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      onClick={() =>
                        updateFormData("Masseur_Certification_URL__c", "")
                      }
                    >
                      <DeleteOutlineIcon
                        style={{ color: "white", fontSize: "24px" }}
                      />
                    </Button>
                  </Box>
                ) : (
                  <FileUpload
                    onImageSelect={handleFileSelect}
                    acceptedFileTypes="image/*,application/pdf"
                    fileInputRef={fileInputRef}
                  />
                )}
              </Box>
            </>
          )}
          <Typography variant="subtitle2" mb={1} className="label required">
            Institute name
          </Typography>
          <TextField
            fullWidth
            placeholder="Name of Institution"
            value={formData.Institute_Name__c || ""}
            onChange={(e) =>
              updateFormData("Institute_Name__c", e.target.value)
            }
          />
        </>
      )}
    </>
  );
};

export default CertificateInstitution;
